import { writable } from 'svelte/store';
const initialState = {
    overlay: false,
    about: false,
    snackbar: {
        text: '',
        icon: '',
    },
};
const { subscribe, set, update } = writable(initialState);
export const ui = {
    subscribe,
    // @TODO: There should be a better way of typing this 'param' parameters?
    toggle: (param) => update((state) => (Object.assign(Object.assign({}, state), { [param]: !state[param] }))),
    activate: (param) => update((state) => (Object.assign(Object.assign({}, state), { [param]: true }))),
    deactivate: (param) => update((state) => (Object.assign(Object.assign({}, state), { [param]: false }))),
    showSnackbar: function ({ text, icon, animationDuration = 1500, }) {
        update((state) => (Object.assign(Object.assign({}, state), { snackbar: {
                text,
                icon,
            } })));
        setTimeout(() => {
            update((state) => (Object.assign(Object.assign({}, state), { snackbar: initialState.snackbar })));
        }, animationDuration);
    },
    reset: () => set(initialState),
};
